export function toCurrentTimezone(date: Date) {
  return date.getTime() - new Date().getTimezoneOffset() * 60 * 1000;
}

export const customLocale = (_number: number, index: number): [string, string] => {
  const locales: Array<[string, string]> = [
    ["just now", "right now"],
    ["%ss ago", "in %ss"], // seconds
    ["1 min ago", "in 1 minute"], // singular minute
    ["%s min ago", "in %s minutes"], // plural minutes
    ["1 h ago", "in 1 hour"], // singular hour
    ["%s h ago", "in %s hours"], // plural hours
    ["1 d ago", "in 1 day"], // singular day
    ["%s d ago", "in %s days"], // plural days
    ["1 w ago", "in 1 week"], // singular week
    ["%s w ago", "in %s weeks"], // plural weeks
    ["1 mo ago", "in 1 month"], // singular month
    ["%s mo ago", "in %s months"], // plural months
    ["1 y ago", "in 1 year"], // singular year
    ["%s y ago", "in %s years"], // plural years
  ];
  return locales[index] || locales[0];
};

export const searchCustomLocale = (_number: number, index: number): [string, string] => {
  const locales: Array<[string, string]> = [
    ["just now", "right now"],
    ["%ss ago", "in %ss"], // seconds
    ["1m ago", "in 1 minute"], // singular minute
    ["%sm ago", "in %s minutes"], // plural minutes
    ["1h ago", "in 1 hour"], // singular hour
    ["%sh ago", "in %s hours"], // plural hours
    ["1d ago", "in 1 day"], // singular day
    ["%sd ago", "in %s days"], // plural days
    ["1w ago", "in 1 week"], // singular week
    ["%sw ago", "in %s weeks"], // plural weeks
    ["1mo ago", "in 1 month"], // singular month
    ["%smo ago", "in %s months"], // plural months
    ["1y ago", "in 1 year"], // singular year
    ["%sy ago", "in %s years"], // plural years
  ];
  return locales[index] || locales[0];
};
